export default "__VITE_ASSET__BJ$Mj_Dm__"